import { registerGroup, registerSymbol, registerText } from '@visactor/vrender-kits';

export function loadPagerComponent() {
  registerGroup();
  registerSymbol();
  registerText();
}
